export const SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS = {
    subTextToAnnual: "seasonalCampaign.banner.subTextToAnnual",
    subText: "seasonalCampaign.banner.subText",
    code: "seasonalCampaign.banner.code",
    upgradeNow: "seasonalCampaign.banner.upgradeNow",
    endsIn: "seasonalCampaign.banner.endsIn",
    off: "seasonalCampaign.banner.off",
} as const;
